import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import LandingPageAIComponent from './LandingPageAIModule/LandingPageAIComponent'
import SoietyBlogAdminManagement from './SoietyBlogsAdmin/SoietyBlogAdminManagement'
import ProtectedRouteAdminModule from './ProtectedRouteAdminModule'
import AdminLogin from './SoietyBlogsAdmin/AdminLoginComponent/AdminLogin'
// import VoiceControl from './VoiceOutput/VoiceControl'

const App = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path='/*' element={<LandingPageAIComponent />} />
          
          {/* Admin Login for Blogs Route */}
          <Route path='/admin/login' element={<AdminLogin />} />
          
          {/* Protected Admin Route */}
          <Route 
            path='/blogmanagement' 
            element={
              <ProtectedRouteAdminModule>
                <SoietyBlogAdminManagement />
              </ProtectedRouteAdminModule>
            } 
          />
          {/* Redirect /admin to blogmanagement */}
          {/* <Route path='/admin' element={<Navigate to="/blogmanagement" replace />} /> */}
        </Routes>
          {/* <VoiceControl/> */}
      </BrowserRouter>
    </>
  )
}

export default App